module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-login",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.doLogin($event)
      }
    }
  }, [_c('div', {
    staticClass: "login-input-container"
  }, [_c('div', {
    staticClass: "login-logo"
  }, [(_vm.channel === 'colaborador') ? _c('img', {
    attrs: {
      "src": require("../../../../assets/auth/img/icone-user.png"),
      "alt": "ícone"
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../../../assets/auth/img/icone-reboque.png"),
      "alt": "ícone"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "login-input"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("Username:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    ref: "user",
    staticClass: "input-login username text-",
    attrs: {
      "type": "text",
      "id": "username",
      "name": "_username",
      "autofocus": "",
      "placeholder": "Nome de usuário, email ou código",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfloat"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "input-login password",
    attrs: {
      "type": "password",
      "id": "password",
      "name": "_password",
      "placeholder": "Senha",
      "required": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfloat"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn-login",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValid
    }
  }, [(!_vm.isLoading) ? _c('span', [_vm._v("Entrar")]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('span', [_vm._v("Aguarde...")]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-i-l"
  }, [_c('input', {
    staticClass: "lembrar",
    attrs: {
      "type": "checkbox",
      "id": "remember_me",
      "name": "_remember_me",
      "value": "on",
      "checked": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "remember_me"
    }
  }, [_vm._v("Continuar conectado")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23c011ef","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/auth/components/Forms/Login.vue
// module id = 1552
// module chunks = 17